import React from 'react'
import { CostValueAndSaveButton } from './components/CostValueAndSaveButton'

export const ZeroCostProductView = (props) => {
    return <div>
        <table>
            <thead>
                <tr>
                    <th>Product Id</th>
                    <th>Product Name</th>
                    <th>Product Cost</th>
                    <th>Save</th>
                </tr>
            </thead>
            <tbody>
                {props.products.map((product) => {
                    return <tr>
                        <td>{product.sku}</td>
                        <td>{product.productTitle}</td>
                        <CostValueAndSaveButton
                            costPrice={product.costPrice}
                            onClickSaveButton={props.onClickSaveButton}
                            sku={product.sku}
                            disableButtons={props.disableButtons}
                            response={props.response}
                        />


                    </tr>
                })}
            </tbody>
        </table>

    </div>
}